import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { QuestionModalComponent } from 'src/app/modals/question-modal/question-modal.component';
import { QuestionService } from 'src/app/providers/question/question.service';
import { DeleteConfirmDialogComponent } from 'src/app/shared/delete-confirm-dialog/delete-confirm-dialog.component';

@Component({
  selector: 'app-question-bank',
  templateUrl: './question-bank.component.html',
  styleUrls: ['./question-bank.component.scss']
})
export class QuestionBankComponent implements OnInit {
  public questionData;

  constructor(public dialog: MatDialog,
    public questionService: QuestionService) {
    this.getquestionData();
  }

  editQuestion(question) {
    const dialogRef = this.dialog.open(QuestionModalComponent, {
      width: '1000px',
      data: {
        id: question.sysRef,
        questiontext: question.questionText,
        Subject_SysRef: question.subject_SysRef,
        answers: question.answers,
        modifiers: question.modifiers,
        title: 'Edit question: ' + question.questiontext
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getquestionData();
    });
  }

  openDialogQuestion(): void {
    const dialogRef = this.dialog.open(QuestionModalComponent, {
      width: '1000px',
      data: {
        title: 'Create new question'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getquestionData();
    });
  }

  downloadQuestions() {
    this.questionService.downloadQuestions()
      .subscribe(
        data => {
          console.log(data)
          const pdfBlob = new Blob([data], { type: 'application/pdf' });
          const url = URL.createObjectURL(pdfBlob);
          window.open(url, "_blank")
          //this.questionData = data;
        },
        err => {
          console.log(err)
        }
      );
  }

  downloadAnswers() {
    this.questionService.downloadAnswers()
      .subscribe(
        data => {
          console.log(data)
          const pdfBlob = new Blob([data], { type: 'application/pdf' });
          const url = URL.createObjectURL(pdfBlob);
          window.open(url, "_blank")
          //this.questionData = data;
        },
        err => {
          console.log(err)
        }
      );
  }

  getquestionData() {
    this.questionService.viewQuestion()
      .pipe(map(
        data => {
          
          return data
        }
      )).subscribe(
        data => {
          console.log(data);
          this.questionData = data;
        });
  }

  ngOnInit(): void {
    this.getquestionData();
  }

  deleteQuestion(questionObj): void {
    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      width: '350px',
      data: {
        component: 'question',
        id: questionObj.sysRef,
        title: 'Confirm Delete',
        message: 'Are you sure, you want to remove question: ' + questionObj.questionText
          + 'Warning: You will also be deleting the answers for the questions'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getquestionData();
    });
  }

}
